export const GRID_CONFIG = {
  default: { sm: 3, md: 3, style: { whiteSpace: 'pre-line' } },
  fullWidth: { sm: 12, md: 12, xs: 12, style: { whiteSpace: 'pre-line' } },
  halfWidth: { sm: 6, md: 6, xs: 6, style: { whiteSpace: 'pre-line' } },
  thirdWidth: { xs: 4, md: 4, lg: 4, style: { whiteSpace: 'pre-line' } },
  wide: { sm: 9, md: 9, xs: 9, style: { whiteSpace: 'pre-line' } }
};
